import axiosPost from "./axiosPost";

export const SFHabitacionUpd = async (credentials, data) => {
    const body = {
        service: "SFHabitacionUpd",
        params: {
            SFHabitacionId: data.SFHabitacionId,
            SFHotelId: data.SFHotelId,
            SFHabitacionNumero: data.SFHabitacionNumero,
            SFHabitacionPiso: data.SFHabitacionPiso,
            SFHabitacionPlazas: data.SFHabitacionPlazas,
            SFHabitacionStatus: data.SFHabitacionStatus,
            SFHabitacionGenero: data.SFHabitacionGenero,
            SFHabitacionVersion: String(data.SFHabitacionVersion ?? ""),
        },
    };

    const result = await axiosPost(body, credentials);
    if (result?.status?.code === 0) {
        return [result.status];
    }
    return result.result;
};
